import styled from '@emotion/styled';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import FONT from '@zola/zola-ui/src/styles/emotion/fonts';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import COLORS from '@zola/zola-ui/src/styles/emotion/colors3';
import MEDIA_QUERY from '@zola/zola-ui/src/styles/emotion/mediaQuery';
import utils from '@zola/zola-ui/src/styles/emotion/utils';

export const LinkDetailsWrapper = styled.div`
  &:not(:last-of-type) {
    margin-bottom: ${SPACING.LG};
  }
`;

export const LinkTitle = styled.div`
  ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_REGULAR)}
  margin-bottom: ${SPACING.S8};
`;

export const LinkDescription = styled.div`
  ${FONT.textSizeCompact(FONT.FONT_SIZE_SMALLER)}
  margin-bottom: ${SPACING.S16};
`;

export const LinkDetailsControls = styled.div<{ singleLine?: boolean }>`
  align-items: center;
  display: flex;
  gap: ${SPACING.S16};
  flex-wrap: wrap;
  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    flex-wrap: ${(props) => (props.singleLine ? 'nowrap' : 'wrap')};
  }
`;

export const LinkDetailsUrl = styled.div<{ fullWidth?: boolean }>`
  padding: ${SPACING.SM};
  border: 1px solid ${COLORS.BLACK_030};
  border-radius: 4px;
  ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_SMALLER)}
  flex: 1 1 auto;
  width: 100%;
  white-space: nowrap;
  overflow-x: scroll;
  ${utils.concealScrollbars}
  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    width: ${(props) => (props.fullWidth ? '100%' : 'auto')};
  }
`;

export const StyledButton = styled(ButtonV3)`
  color: ${COLORS.WHITE_100} !important;
`;

export const StyledLink = styled(ButtonV3)`
  text-decoration: none !important;
`;
